// extracted by mini-css-extract-plugin
export default {"dropMenu":"common_dropMenu__uTHeG"};